module.exports = __webpack_public_path__ + "static/media/img_review.79ac83e9.png";